export const getMess = (user) =>
  fetch(`https://astrange.azurewebsites.net/messages/${user}`)
    .then((res) => {
      if (res.ok) {
        return res.json();
      }
    })
    .then((jsonRes) => jsonRes);

export const getPosts = () =>
  fetch("https://astrange.azurewebsites.net/posts")
    .then((res) => {
      if (res.ok) {
        return res.json();
      }
    })
    .then((jsonRes) => jsonRes);
